module.exports = {"210911001":"西苑街道","210911002":"北苑街道","210911003":"东苑街道","210911004":"学苑街道","210911005":"中苑街道","210911006":"华东街道","210911102":"四合镇","210911401":"六家子管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210911.json
// module id = 568
// module chunks = 0